import LicenseInfoList from './LicenseInfoList';
export default LicenseInfoList;
